import { Button } from '../../../ui/2.0/ca-ui';

export class VREditToolsPanel {
  constructor (vr, editor, toolbar) {
    this.vr = vr;
    this.editor = editor;
    this.toolbar = toolbar;

    this.editToolsPanel = $('<div class="ca-vr_editortoolbar-tools"></div>');
    this.toolbar.append(this.editToolsPanel);

    // temporarily disable until we start the story for implementing hotspots undo/redo functionality
    // this.initControls();
  }

  // @TODO: Add contextual controls based on the thing you're currently editing
  initControls () {
    // add undo and redo buttons
    this.undoButton = new Button({
      icon: 'undo',
      label: 'Undo'
    });

    this.undoButton.on('click', function () {
      this.vr.undoRedo.handleUndo();
    }.bind(this));
    this.editToolsPanel.append(this.undoButton.el);

    this.redoButton = new Button({
      icon: 'redo',
      label: 'Redo'
    });

    this.redoButton.on('click', function () {
      this.vr.undoRedo.handleRedo();
    }.bind(this));
    this.editToolsPanel.append(this.redoButton.el);
  }
}
